module.exports = __webpack_public_path__ + "img/2.4_Students-Trainees_4_Loggins.044ebc78204396e38ccc051ab70959c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2.4_Students-Trainees_4_Loggins.png
// module id = 767
// module chunks = 0